import { service } from ".";

export default {
  getAll: () => service.get("/news"),
  getOne: (id) => service.get(`/news/${id}`),
  getAllPaginate: (query) => service.get(`/news/paginate?${query}`),
  create: (data) => service.post("/news", data),
  update: (id, data) => service.put(`/news/${id}`, data),
  delete: (id) => service.delete(`/news/${id}`),
};
